import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import ProductCard from '../components/ProductCard';
import toast from 'react-hot-toast';

const PH = 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=800&q=80';
const SLIDES = [
  { id:1, poster:'https://images.unsplash.com/photo-1617627143233-1c3e1c33893c?w=1400&q=85', tag:'✦ New Wedding Collection 2024 ✦', title:'Bridal Kanjivaram', italic:'Dreams', desc:'Pure silk, 24-carat zari, handwoven by master artisans.', cta:'Explore Bridal', ctaLink:'/collections/wedding', cta2:'All Silk Sarees', cta2Link:'/collections/silk-sarees', overlay:'linear-gradient(120deg,rgba(26,15,15,0.82) 0%,rgba(26,15,15,0.35) 55%,rgba(26,15,15,0.10) 100%)' },
  { id:2, poster:'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=1400&q=85', tag:'✦ Fresh Off The Loom ✦', title:'Pochampally Ikat', italic:'Heritage', desc:'Resist-dyed geometric masterpieces. Nature-inspired. Timeless.', cta:'Shop Ikat', ctaLink:'/collections/ikat', cta2:'New Arrivals', cta2Link:'/collections?is_new=1', overlay:'linear-gradient(120deg,rgba(26,15,15,0.78) 0%,rgba(26,15,15,0.30) 50%,transparent 100%)' },
];
const CAT_TILES = [
  { label:'Kanjivaram\nSilk',   slug:'silk-sarees',   img:'https://images.unsplash.com/photo-1595274459742-4a41d35784f2?w=700&q=80' },
  { label:'Wedding\nCollection',slug:'wedding',        img:'https://images.unsplash.com/photo-1617627143233-1c3e1c33893c?w=700&q=80' },
  { label:'Cotton\nHandloom',   slug:'cotton-sarees',  img:'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=700&q=80' },
  { label:'Ikat\nPatterns',     slug:'ikat',           img:'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=700&q=80' },
  { label:'Zari / Jari\nWork',  slug:'jari-sarees',    img:'https://images.unsplash.com/photo-1609177028477-f1e7e2abe71c?w=700&q=80' },
  { label:'Festival\nSpecial',  slug:'festival',       img:'https://images.unsplash.com/photo-1614252369475-531eba835eb1?w=700&q=80' },
];
const TRUST = [
  {icon:'🏺',label:'GI Certified',sub:'Govt of India certified'},
  {icon:'✋',label:'100% Handwoven',sub:'By master weavers'},
  {icon:'🚚',label:'Free Shipping',sub:'Orders above ₹999'},
  {icon:'↩️',label:'7-Day Returns',sub:'Hassle-free'},
  {icon:'🔒',label:'Secure Payments',sub:'UPI · Cards · COD'},
];
const TESTIMONIALS = [
  {name:'Priya V.',loc:'Chennai',stars:5,text:'The Kanjivaram is breathtaking — the zari work is exquisite. Packed beautifully and delivered fast.'},
  {name:'Anitha R.',loc:'Hyderabad',stars:5,text:"Wore it to my daughter's wedding. The compliments haven't stopped. Genuinely authentic quality."},
  {name:'Meera K.',loc:'Bengaluru',stars:5,text:'The Ikat cotton is so lightweight and the colors are still vibrant after many washes. Truly handwoven.'},
  {name:'Lakshmi S.',loc:'Tirupati',stars:5,text:'Ordered the Diwali silk — arrived in 3 days, stunning packaging. Will definitely be ordering again!'},
];

export default function HomePage() {
  const [categories, setCategories] = useState([]);
  const [featured,   setFeatured]   = useState([]);
  const [newArr,     setNewArr]     = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [slide,      setSlide]      = useState(0);
  const [videoModal, setVideoModal] = useState(false);
  const [testiIdx,   setTestiIdx]   = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    Promise.all([
      api.get('/categories'),
      api.get('/products?featured=1&limit=8'),
      api.get('/products?is_new=1&limit=8'),
    ]).then(([cats, feat, newP]) => {
      setCategories(cats.data || []);
      setFeatured(feat.data?.products || []);
      setNewArr(newP.data?.products   || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const nextSlide = useCallback(() => setSlide(s => (s+1) % SLIDES.length), []);
  useEffect(() => { timer.current = setInterval(nextSlide, 6000); return () => clearInterval(timer.current); }, [nextSlide]);
  const goSlide = i => { clearInterval(timer.current); setSlide(i); timer.current = setInterval(nextSlide, 6000); };

  useEffect(() => { const t = setInterval(() => setTestiIdx(i => (i+1) % TESTIMONIALS.length), 4000); return () => clearInterval(t); }, []);
  useEffect(() => { const h = e => { if(e.key==='Escape') setVideoModal(false); }; window.addEventListener('keydown',h); return () => window.removeEventListener('keydown',h); }, []);

  if (loading) return <div style={{paddingTop:110}}><div className="spinner"/></div>;
  const sl = SLIDES[slide];

  return (
    <div style={{paddingTop:0}}>
      {/* ── HERO SLIDER ── */}
      <section style={{position:'relative',height:'100svh',minHeight:520,maxHeight:900,overflow:'hidden',display:'flex',alignItems:'center'}}>
        <div style={{position:'absolute',inset:0}}>
          {SLIDES.map((s,i) => <div key={s.id} style={{position:'absolute',inset:0,backgroundSize:'cover',backgroundPosition:'center',backgroundImage:`url(${s.poster})`,transition:'opacity 1.2s ease',opacity:i===slide?1:0}}/>)}
          <div style={{position:'absolute',inset:0,opacity:0.12,backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill='none' stroke='%23c9a84c' stroke-width='0.5'%3E%3Cpolygon points='20,4 36,20 20,36 4,20'/%3E%3Cpolygon points='20,10 30,20 20,30 10,20'/%3E%3Ccircle cx='20' cy='20' r='2.5' fill='%23c9a84c'/%3E%3C/g%3E%3C/svg%3E")`,backgroundSize:'40px 40px'}}/>
          <div style={{position:'absolute',inset:0,background:sl.overlay}}/>
        </div>
        <div style={{position:'relative',zIndex:10,maxWidth:1320,margin:'0 auto',padding:'0 clamp(20px,4vw,60px)',width:'100%',animation:'fadeInUp 0.8s ease'}}>
          <div style={{fontSize:11,letterSpacing:4,textTransform:'uppercase',color:'#c9a84c',marginBottom:20,fontFamily:"'Jost',sans-serif"}}>{sl.tag}</div>
          <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(2.4rem,6vw,5.5rem)',color:'#fff',lineHeight:1.1,marginBottom:20}}>
            {sl.title.split('\n').map((l,i) => <span key={i} style={{display:'block'}}>{l}</span>)}
            <em style={{fontStyle:'italic',color:'#e8c96a'}}>{sl.italic}</em>
          </h1>
          <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(15px,2vw,19px)',color:'rgba(255,255,255,0.82)',lineHeight:1.8,marginBottom:32,maxWidth:480,fontStyle:'italic'}}>{sl.desc}</p>
          <div style={{display:'flex',gap:14,flexWrap:'wrap',marginBottom:28}}>
            <Link to={sl.ctaLink} className="btn btn-gold">{sl.cta}</Link>
            <Link to={sl.cta2Link} className="btn" style={{color:'#fff',border:'2px solid rgba(255,255,255,0.55)'}}>{sl.cta2}</Link>
          </div>
          <button onClick={() => setVideoModal(true)} style={{display:'flex',alignItems:'center',gap:12,background:'none',border:'none',cursor:'pointer',color:'rgba(255,255,255,0.85)',fontFamily:"'Jost',sans-serif",fontSize:12,letterSpacing:2,textTransform:'uppercase',padding:0}}>
            <div style={{width:42,height:42,borderRadius:'50%',background:'rgba(255,255,255,0.18)',border:'1.5px solid rgba(255,255,255,0.45)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,paddingLeft:3}}>▶</div>
            Watch the Story
          </button>
        </div>
        {/* Dots */}
        <div style={{position:'absolute',bottom:28,left:'50%',transform:'translateX(-50%)',display:'flex',gap:8,zIndex:20}}>
          {SLIDES.map((_,i) => <button key={i} onClick={() => goSlide(i)} style={{width:i===slide?24:8,height:8,borderRadius:i===slide?4:'50%',background:i===slide?'#fff':'rgba(255,255,255,0.4)',border:'none',cursor:'pointer',padding:0,transition:'all 0.3s'}}/>)}
        </div>
        {/* Arrows */}
        <button onClick={() => goSlide((slide-1+SLIDES.length)%SLIDES.length)} style={{position:'absolute',left:20,top:'50%',transform:'translateY(-50%)',background:'rgba(255,255,255,0.15)',backdropFilter:'blur(4px)',border:'1px solid rgba(255,255,255,0.25)',color:'#fff',width:48,height:48,borderRadius:'50%',fontSize:28,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',zIndex:20,lineHeight:1}}>‹</button>
        <button onClick={() => goSlide((slide+1)%SLIDES.length)} style={{position:'absolute',right:20,top:'50%',transform:'translateY(-50%)',background:'rgba(255,255,255,0.15)',backdropFilter:'blur(4px)',border:'1px solid rgba(255,255,255,0.25)',color:'#fff',width:48,height:48,borderRadius:'50%',fontSize:28,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',zIndex:20,lineHeight:1}}>›</button>
      </section>

      {/* ── MARQUEE ── */}
      <div style={{background:'#7a1f1f',overflow:'hidden',padding:'13px 0'}}>
        <div style={{display:'flex',width:'max-content',animation:'marquee 35s linear infinite',gap:0}}>
          {Array(8).fill(['Silk Sarees','Cotton Weaves','Ikat Heritage','Jari Work','Wedding Drapes','Festival Collections','GI Certified','Since 1985']).flat().map((t,i) => <span key={i} style={{fontFamily:"'Jost',sans-serif",fontSize:11,letterSpacing:3,textTransform:'uppercase',color:'#e8c96a',padding:'0 28px',whiteSpace:'nowrap'}}>✦ {t}</span>)}
        </div>
      </div>

      {/* ── TRUST BADGES ── */}
      <div style={{background:'#fff',borderBottom:'1px solid var(--border)',padding:'20px 0'}}>
        <div className="container">
          <div className="trust-grid">
            {TRUST.map(t => (
              <div key={t.label} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0'}}>
                <span style={{fontSize:22,flexShrink:0}}>{t.icon}</span>
                <div>
                  <div style={{fontFamily:"'Jost',sans-serif",fontSize:12,fontWeight:600,color:'#2d1f1f'}}>{t.label}</div>
                  <div style={{fontFamily:"'Jost',sans-serif",fontSize:11,color:'#8a7968'}}>{t.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── CATEGORY TILES ── */}
      <section style={{padding:'72px 0'}}>
        <div className="container">
          <div style={{marginBottom:40}}>
            <div className="section-subtitle">Browse by Weave</div>
            <h2 className="section-title">Our Collections</h2>
            <div className="section-divider"/>
          </div>
          <div className="cat-tiles-grid">
            {CAT_TILES.map(cat => (
              <Link key={cat.slug} to={`/collections/${cat.slug}`} className="cat-tile-item" style={{position:'relative',overflow:'hidden',display:'block',border:'1px solid var(--border)',cursor:'pointer'}}>
                <img src={cat.img} alt={cat.label.replace('\n',' ')} style={{width:'100%',height:'100%',objectFit:'cover',transition:'transform 0.6s',display:'block'}} onError={e=>{e.target.src=PH;}} loading="lazy"/>
                <div style={{position:'absolute',inset:0,background:'linear-gradient(to top,rgba(26,15,15,0.82) 0%,rgba(26,15,15,0.15) 55%,transparent 100%)'}}/>
                <div style={{position:'absolute',bottom:0,left:0,right:0,padding:'16px 12px',textAlign:'center'}}>
                  <div style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(11px,1.2vw,15px)',color:'#fff',fontStyle:'italic',lineHeight:1.3,marginBottom:4}}>
                    {cat.label.split('\n').map((l,i) => <span key={i} style={{display:'block'}}>{l}</span>)}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── FEATURED PRODUCTS ── */}
      {featured.length > 0 && (
        <section style={{padding:'72px 0',background:'#fff'}}>
          <div className="container">
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-end',marginBottom:36,flexWrap:'wrap',gap:12}}>
              <div><div className="section-subtitle">Handpicked for You</div><h2 className="section-title">Featured Sarees</h2></div>
              <Link to="/collections?featured=1" className="btn btn-outline" style={{fontSize:11}}>View All →</Link>
            </div>
            <div className="scroll-row">{featured.slice(0,8).map(p => <ProductCard key={p.id} product={p}/>)}</div>
          </div>
        </section>
      )}

      {/* ── LOOKBOOK — Bridal ── */}
      <section style={{padding:'80px 0',background:'#f7f0e6'}}>
        <div className="container">
          <div className="lookbook-grid">
            <div style={{position:'relative'}}>
              <div style={{position:'relative',overflow:'hidden'}}>
                <img src="https://images.unsplash.com/photo-1617627143233-1c3e1c33893c?w=800&q=80" alt="Bridal" style={{width:'100%',aspectRatio:'4/5',objectFit:'cover'}} loading="lazy" onError={e=>{e.target.style.background='#f7f0e6';e.target.style.display='none';}} />
                <button className="play-overlay" onClick={() => setVideoModal(true)} style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.22)',border:'none',cursor:'pointer',transition:'background 0.3s'}}>
                  <div style={{width:68,height:68,borderRadius:'50%',background:'rgba(255,255,255,0.93)',display:'flex',alignItems:'center',justifyContent:'center',paddingLeft:5,fontSize:26,boxShadow:'0 6px 28px rgba(0,0,0,0.28)'}}>▶</div>
                </button>
              </div>
              <div style={{position:'absolute',right:-20,bottom:32,background:'#fff',padding:'16px 20px',boxShadow:'0 8px 32px rgba(0,0,0,0.12)',border:'1px solid var(--border)',textAlign:'center',minWidth:140}} className="hidden-mobile">
                <div style={{fontSize:28,marginBottom:4}}>🥻</div>
                <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:16,color:'#7a1f1f',fontWeight:600}}>100% Authentic</div>
                <div style={{fontSize:11,color:'#8a7968'}}>GI Certified Weave</div>
              </div>
            </div>
            <div>
              <div className="section-subtitle">Wedding collection</div>
              <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.8rem,3vw,3rem)',color:'#7a1f1f',fontStyle:'italic',lineHeight:1.2,marginBottom:16}}>Bridal Dreams</h2>
              <div style={{width:48,height:2,background:'linear-gradient(90deg,var(--gold),transparent)',marginBottom:20}}/>
              <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:19,color:'#5a3a3a',lineHeight:1.9,marginBottom:20}}>Step into matrimony draped in the finest Venkatagiri bridal silks. Each saree carries the blessings of ancient looms and the brilliance of pure gold zari.</p>
              <div style={{display:'flex',flexWrap:'wrap',gap:'8px 24px',marginBottom:28}}>
                {['Handwoven','Pure Material','GI Certified','Artisan Made'].map(f => <span key={f} style={{fontFamily:"'Jost',sans-serif",fontSize:12,fontWeight:600,color:'#7a1f1f'}}>✓ {f}</span>)}
              </div>
              <Link to="/collections/wedding" className="btn btn-primary">Shop Bridal</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── NEW ARRIVALS ── */}
      {newArr.length > 0 && (
        <section style={{padding:'72px 0'}}>
          <div className="container">
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-end',marginBottom:36,flexWrap:'wrap',gap:12}}>
              <div><div className="section-subtitle">Fresh Off the Loom</div><h2 className="section-title">New Arrivals</h2></div>
              <Link to="/collections?is_new=1" className="btn btn-outline" style={{fontSize:11}}>View All →</Link>
            </div>
            <div className="scroll-row">{newArr.slice(0,8).map(p => <ProductCard key={p.id} product={p}/>)}</div>
          </div>
        </section>
      )}

      {/* ── HERITAGE BANNER ── */}
      <section style={{position:'relative',padding:'96px 0',overflow:'hidden',minHeight:460}}>
        <div style={{position:'absolute',inset:0,background:"url('https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=1400&q=70') center/cover no-repeat"}}/>
        <div style={{position:'absolute',inset:0,background:'rgba(26,15,15,0.82)'}}/>
        <div className="container" style={{position:'relative',zIndex:2}}>
          <div className="heritage-content" style={{maxWidth:640}}>
            <div style={{fontSize:11,letterSpacing:3,color:'#c9a84c',marginBottom:12,textTransform:'uppercase'}}>Our Story</div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(2rem,4vw,3.2rem)',color:'#fff',lineHeight:1.2,marginBottom:20}}>Woven into the<br/><em>Fabric of History</em></h2>
            <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,color:'rgba(255,255,255,0.75)',lineHeight:1.9,marginBottom:32}}>Venkatagiri sarees — celebrated for fine-count cotton and exquisite zari — have adorned generations. Each piece carries the Geographical Indication certification, a mark of authentic craftsmanship from the ancient looms of Andhra Pradesh.</p>
            <div className="heritage-stats-grid" style={{marginBottom:32}}>
              {[{n:'200+',l:'Designs'},{n:'38 Yrs',l:'Legacy'},{n:'15k+',l:'Customers'},{n:'100%',l:'Handwoven'}].map(st => (
                <div key={st.n} style={{textAlign:'center'}}>
                  <div style={{fontFamily:"'Playfair Display',serif",fontSize:36,color:'#e8c96a',fontWeight:700}}>{st.n}</div>
                  <div style={{fontSize:10,letterSpacing:2,textTransform:'uppercase',color:'rgba(255,255,255,0.55)',fontFamily:"'Jost',sans-serif",marginTop:2}}>{st.l}</div>
                </div>
              ))}
            </div>
            <Link to="/collections" className="btn btn-gold">Discover Heritage →</Link>
          </div>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section style={{padding:'72px 0',background:'#2d1f1f'}}>
        <div className="container">
          <div style={{textAlign:'center',marginBottom:48}}>
            <div style={{fontSize:10,letterSpacing:3,color:'#c9a84c',marginBottom:8,textTransform:'uppercase'}}>Why Choose Us</div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.6rem,3vw,2.5rem)',color:'#fff',fontStyle:'italic'}}>Crafted with Commitment</h2>
          </div>
          <div className="why-grid">
            {[{icon:'🏺',title:'Heritage Craft',desc:'200-year-old loom traditions from Nellore district.'},{icon:'🌿',title:'Pure Materials',desc:'GI certified pure silk, cotton & natural zari only.'},{icon:'🎁',title:'Gift Packaging',desc:'Signature handcrafted boxes for every order.'},{icon:'🚚',title:'Free Shipping',desc:'Complimentary delivery above ₹999 across India.'},{icon:'↩️',title:'Easy Returns',desc:'7-day hassle-free returns with full refund.'},{icon:'💬',title:'Expert Advice',desc:'Our saree experts help you choose the perfect weave.'}].map(w => (
              <div key={w.title} style={{padding:28,border:'1px solid rgba(255,255,255,0.08)',background:'rgba(255,255,255,0.03)'}}>
                <div style={{fontSize:36,marginBottom:14}}>{w.icon}</div>
                <h3 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:21,color:'#e8c96a',marginBottom:10}}>{w.title}</h3>
                <p style={{fontFamily:"'Jost',sans-serif",fontSize:13,color:'rgba(255,255,255,0.55)',lineHeight:1.7}}>{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section style={{padding:'72px 0',background:'#fdf8f0',overflow:'hidden'}}>
        <div className="container">
          <div style={{textAlign:'center',marginBottom:40}}>
            <div className="section-subtitle">Customer Love</div>
            <h2 className="section-title">What They Say</h2>
            <div className="section-divider" style={{margin:'0 auto'}}/>
          </div>
          {/* Desktop 3-col */}
          <div className="hidden-mobile testi-grid">
            {TESTIMONIALS.slice(0,3).map(t => <TestiCard key={t.name} t={t}/>)}
          </div>
          {/* Mobile carousel */}
          <div className="show-mobile">
            <TestiCard t={TESTIMONIALS[testiIdx]}/>
            <div style={{display:'flex',justifyContent:'center',gap:8,marginTop:20}}>
              {TESTIMONIALS.map((_,i) => <button key={i} onClick={() => setTestiIdx(i)} style={{width:8,height:8,borderRadius:'50%',border:'none',cursor:'pointer',background:i===testiIdx?'#7a1f1f':'#e8ddd0',padding:0}}/>)}
            </div>
          </div>
        </div>
      </section>

      {/* ── NEWSLETTER ── */}
      <InstagramPreview/>
      <RecentlyViewed/>
      <NewsletterSection/>

      {/* ── VIDEO MODAL ── */}
      {videoModal && (
        <div className="modal-overlay" onClick={() => setVideoModal(false)}>
          <button className="modal-close" onClick={() => setVideoModal(false)}>✕</button>
          <div style={{width:'90vw',maxWidth:900,aspectRatio:'16/9',background:'#000',position:'relative',zIndex:10}} onClick={e => e.stopPropagation()}>
            <iframe style={{width:'100%',height:'100%',border:'none'}} src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&rel=0" title="Venkatagiri Handlooms" allow="autoplay; fullscreen" allowFullScreen/>
          </div>
        </div>
      )}
    </div>
  );
}

function TestiCard({t}) {
  return (
    <div style={{background:'#fff',padding:'36px 28px',border:'1px solid var(--border)',boxShadow:'0 2px 16px rgba(122,31,31,0.05)'}}>
      <div style={{color:'#c9a84c',fontSize:13,marginBottom:12,letterSpacing:2}}>{'★'.repeat(t.stars)}</div>
      <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,color:'#2d1f1f',lineHeight:1.8,fontStyle:'italic',marginBottom:20}}>"{t.text}"</p>
      <div style={{display:'flex',alignItems:'center',gap:12}}>
        <div style={{width:42,height:42,borderRadius:'50%',background:'#7a1f1f',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:"'Playfair Display',serif",fontSize:18,flexShrink:0}}>{t.name[0]}</div>
        <div>
          <div style={{fontFamily:"'Jost',sans-serif",fontWeight:600,fontSize:14,color:'#2d1f1f'}}>{t.name}</div>
          <div style={{fontFamily:"'Jost',sans-serif",fontSize:11,color:'#8a7968',letterSpacing:1}}>{t.loc}</div>
        </div>
      </div>
    </div>
  );
}

function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [busy, setBusy]   = useState(false);
  const handleSub = async e => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try { const r = await api.post('/newsletter', { email }); toast.success(r.message || 'Subscribed! 🎉'); setEmail(''); }
    catch (err) { toast.error(err.message); }
    finally { setBusy(false); }
  };
  return (
    <section style={{background:'#7a1f1f',padding:'64px 0'}}>
      <div className="container">
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:32,flexWrap:'wrap'}}>
          <div>
            <div style={{fontSize:10,letterSpacing:3,textTransform:'uppercase',color:'#e8c96a',marginBottom:8}}>Join Our Community</div>
            <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.6rem,2.5vw,2.2rem)',color:'#fff',fontStyle:'italic',marginBottom:6}}>Stories in Every Thread</h3>
            <p style={{color:'rgba(255,255,255,0.65)',fontSize:14}}>Exclusive collections, weaving stories & artisan spotlights.</p>
          </div>
          <form onSubmit={handleSub} style={{display:'flex',gap:10,flex:1,maxWidth:440,minWidth:260}}>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address" required style={{flex:1,padding:'13px 16px',border:'none',background:'rgba(255,255,255,0.14)',color:'#fff',fontSize:14,outline:'none'}}/>
            <button type="submit" className="btn btn-gold" disabled={busy} style={{whiteSpace:'nowrap',flexShrink:0}}>{busy?'...':'Subscribe'}</button>
          </form>
        </div>
      </div>
    </section>
  );
}

// ── Instagram Preview Component ──────────────────────────────
function InstagramPreview() {
  const PREVIEW_IMGS = [
    'https://images.unsplash.com/photo-1617627143233-1c3e1c33893c?w=400&q=80',
    'https://images.unsplash.com/photo-1595274459742-4a41d35784f2?w=400&q=80',
    'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=400&q=80',
    'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400&q=80',
    'https://images.unsplash.com/photo-1614252369475-531eba835eb1?w=400&q=80',
    'https://images.unsplash.com/photo-1609177028477-f1e7e2abe71c?w=400&q=80',
  ];
  return (
    <section style={{padding:'72px 0',background:'#fff'}}>
      <div className="container">
        <div style={{textAlign:'center',marginBottom:32}}>
          <div className="section-subtitle">Follow the Journey</div>
          <h2 className="section-title">@venkatagirihandlooms</h2>
          <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:17,color:'#8a7968',fontStyle:'italic',marginTop:4}}>Daily saree stories, weaving reels & artisan spotlights</p>
        </div>
        <div className="insta-preview-grid" style={{marginBottom:24}}>
          {PREVIEW_IMGS.map((img,i) => (
            <Link key={i} to="/instagram" style={{position:'relative',aspectRatio:'1',overflow:'hidden',display:'block',background:'#f7f0e6'}}>
              <img src={img} alt="" onError={e=>{e.target.src='https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400&q=60';}} style={{width:'100%',height:'100%',objectFit:'cover',transition:'transform 0.4s'}}
                onMouseEnter={e=>e.target.style.transform='scale(1.08)'} onMouseLeave={e=>e.target.style.transform='scale(1)'}/>
              <div style={{position:'absolute',inset:0,background:'rgba(122,31,31,0)',transition:'background 0.3s',display:'flex',alignItems:'center',justifyContent:'center'}}
                onMouseEnter={e=>e.currentTarget.style.background='rgba(122,31,31,0.5)'}
                onMouseLeave={e=>e.currentTarget.style.background='rgba(122,31,31,0)'}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white" style={{opacity:0,transition:'opacity 0.3s'}}
                  onMouseEnter={e=>e.currentTarget.style.opacity='1'}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </div>
            </Link>
          ))}
        </div>
        <div style={{textAlign:'center'}}>
          <Link to="/instagram" className="btn btn-outline" style={{fontSize:11}}>View All on Instagram →</Link>
        </div>
      </div>
    </section>
  );
}

// ── Recently Viewed Component ─────────────────────────────────
function RecentlyViewed() {
  const [items, setItems] = React.useState([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    try {
      const raw = localStorage.getItem('vkg_recently_viewed');
      if (raw) setItems(JSON.parse(raw).slice(0, 8));
    } catch {}
  }, []);

  if (items.length < 2) return null;

  const PH = 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=150&q=60';
  const resImg = ph => !ph ? PH : ph.startsWith('http') ? ph : `https://shop.venkatagirihandlooms.com/${ph.replace(/^\/+/,'')}`;

  return (
    <section style={{padding:'48px 0',background:'#f7f0e6',borderTop:'1px solid var(--border)'}}>
      <div className="container">
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
          <div>
            <div className="section-subtitle">Your Browsing History</div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.2rem,2vw,1.6rem)',color:'#7a1f1f',fontStyle:'italic'}}>Recently Viewed</h2>
          </div>
          <button onClick={()=>{localStorage.removeItem('vkg_recently_viewed');setItems([]);}} style={{fontSize:11,color:'#aaa',background:'none',border:'none',cursor:'pointer',fontFamily:"'Jost',sans-serif",textDecoration:'underline'}}>Clear</button>
        </div>
        <div className="recently-strip">
          {items.map(p => {
            const fp = p.selling_price * (1-(p.discount_pct||0)/100);
            return (
              <div key={p.id} className="recently-item" onClick={()=>navigate(`/product/${p.slug}`)}>
                <img src={resImg(p.photo)} alt={p.name} onError={e=>{e.target.src=PH;}}/>
                <div className="recently-item-name">{p.name}</div>
                <div className="recently-item-price">₹{fp.toLocaleString('en-IN',{maximumFractionDigits:0})}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
